import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {  combineLatest, map, take } from 'rxjs';
import { CurrentBasketService } from 'src/app/basket/services/current-basket.service';
import { select, Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/stores/appState.interface';
import * as CompanyActions from "../../stores/global/companies/company-actions";
import { companySelector } from 'src/app/stores/global/companies/company-selectors';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

@UntilDestroy()
@Component({
    selector: 'app-company-basket-dropdown',
    templateUrl: './company-basket-dropdown.component.html',
    styleUrls: ['./company-basket-dropdown.component.scss'],
    standalone: false
})
export class CompanyBasketDropdownComponent implements OnInit {

  constructor(
    private store: Store<AppStateInterface>,
    private currentBasketService : CurrentBasketService,
    private translocoService: TranslocoService
    ) { }

  form: UntypedFormGroup;
  defaultItem: any = { name: this.translocoService.translate('basket.dropdownDefault'), tenantId: null};

  private currentCompany$ =
    this.currentBasketService.currentCompany$;

    
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };

  ngOnInit(): void {
    this.store.dispatch(CompanyActions.getCompanies());
    this.initFrom();
  }

  vm$ = combineLatest([ 
    this.store.pipe(select(companySelector)),
  ]).pipe(
    map(([
      companies,
    ]) => ({
      companies,
    }))
  );

  initFrom(){
    this.form = new UntypedFormGroup({
      company: new UntypedFormControl()
    })

    this.currentCompany$
    .pipe(
      untilDestroyed(this),
      take(1))
    .subscribe(companyObj => {
      if(!companyObj){
        this.currentBasketService.setActiveCompany(this.defaultItem);
      }
      this.form.patchValue({
        company: companyObj
      })
    })

    this.form.valueChanges.subscribe(event => {
      this.currentBasketService.setActiveCompany(event.company);
    });
  }
}
